import React, { useState } from "react";
import Header from "../components/Header";
import styles from "./ManualEntryView.module.css";

interface ManualEntryViewProps {
  initialBody?: string;
  initialSubject?: string;
  onAnalyse: (body: string, subject: string) => void;
  onClose: () => void;
  onBack: () => void;
}

export default function ManualEntryView({
  initialBody = "",
  initialSubject = "",
  onAnalyse,
  onClose,
  onBack,
}: ManualEntryViewProps) {
  const [body, setBody] = useState(initialBody);
  const [subject, setSubject] = useState(initialSubject);

  const isReady = body.length >= 50;

  const handleSubmit = () => {
    if (isReady) {
      onAnalyse(body, subject);
    }
  };

  return (
    <div className={styles.panel}>
      <Header onBack={onBack} />
      <div className={styles.body}>
        <div className={styles.content}>
          <div className={styles.sectionRow}>
            <span className={styles.sectionLabel}>Paste your email below</span>
            <div className={styles.divider} />
          </div>

          <div className={styles.fieldGroup}>
            <label>
              Email body <span className={styles.required}>*</span>
            </label>
            <textarea
              value={body}
              onChange={(e) => setBody(e.target.value)}
              placeholder="Hi Sarah, I wanted to reach out because..."
              className={styles.bodyTextarea}
              rows={8}
            />
            <div className={styles.charCount}>
              {body.length} characters
              {body.length >= 50 && <span className={styles.minMet}> · Minimum met</span>}
            </div>
          </div>

          <div className={styles.fieldGroup}>
            <label>
              Subject line <span className={styles.optional}>(optional)</span>
            </label>
            <input
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="e.g. Following up on your Q2 expansion"
              className={styles.subjectInput}
            />
          </div>
        </div>

        <div className={styles.footer}>
          <button
            className={`${styles.cta} ${isReady ? styles.ctaReady : styles.ctaDisabled}`}
            onClick={handleSubmit}
            disabled={!isReady}
            type="button"
          >
            <span className={styles.ctaIcon}>▶</span>
            <span>Analyse This Email</span>
          </button>
          <span className={styles.wizardHint}>Context wizard comes next</span>
        </div>
      </div>
    </div>
  );
}
